<template>
  <div>
    <div class="flex flex-wrap">
      <div class="w-full sm:w-1/3">
        <v-icon name="user-tag" class="detail-icon" />
        <h2 class="meta-title">
          Subscriber Count
          <span class="meta-title-info">
            accepts marketing
          </span>
        </h2>

        <p class="meta-amount">
          {{ subscriberCount }}
        </p>
      </div>

      <div class="w-full sm:w-1/3">
        <v-icon name="paper-plane" class="detail-icon" />
        <h2 class="meta-title">
          Campaigns Sent
          <span class="meta-title-info">
            this month
          </span>
        </h2>

        <p class="meta-amount">
          {{ campaignsSentThisMonth }}
        </p>
      </div>

      <div class="w-full sm:w-1/3">
        <v-icon name="envelope" class="detail-icon" />
        <h2 class="meta-title">
          Emails Sent
          <span class="meta-title-info">
            this month
          </span>
        </h2>

        <p class="meta-amount">
          {{ emailsSentThisMonth || 0 }}
        </p>
      </div>
    </div>

    <p class="mb-0">
      <a
        href="http://help.promo.ai/article/why-are-my-subscriber-numbers-lower-than-my-shopify-customer-numbers/?v=1559020692251"
        target="_blank"
        class="text-sm text-grey italic"
      >
        Why is my subscriber count lower than expected?
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: "SendCampaignStats",
  props: {
    campaignsSentThisMonth: {
      type: Number,
      default: 0,
    },
    emailsSentThisMonth: {
      type: Number,
      default: 0,
    },
    subscriberCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
.detail-icon {
  @apply text-brand mb-2 text-2xl;
}

.meta-title {
  @apply text-base mb-2 text-grey-dark relative;

  @screen md {
    @apply text-lg;
  }
}

.meta-title-info {
  @apply text-grey-dark text-xs ml-2 font-light font-sans block mt-2;

  @screen md {
    @apply text-sm mt-2 ml-0;
  }
}

.meta-amount {
  @apply text-xl font-lato text-support;

  @screen md {
    @apply text-4xl;
  }
}
</style>
